<form [formGroup]="supportForm">

    <!-- Title -->
    <ms-input-label [isRequired]="isFieldRequired(supportForm, 'title')" [labelText]="'Title'" />
    <input
        type="text"
        id="title"
        formControlName="title"
        [required]="isFieldRequired(supportForm, 'title')"
        maxlength="150"
        class="form-control"
        [class.is-invalid]="supportForm.get('title')?.invalid && supportForm.get('title')?.touched"
        [class.is-valid]="supportForm.get('title')?.valid && supportForm.get('title')?.touched" />
    @if (supportForm.get('title')?.invalid && supportForm.get('title')?.touched) {
        <div class="error-messages">
            @if (supportForm.get('title')?.errors?.['required']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.SupportTicketTitleRequired }}</p>
            }
            @if (supportForm.get('title')?.errors?.['maxlength']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.SupportTicketTitleMaxLength }}</p>
            }
        </div>
    }

    <!-- Body -->
    <ms-input-label [isRequired]="isFieldRequired(supportForm, 'body')" [labelText]="'Message'" class="mt-3" />
    <ms-rich-text-editor
        formControlName="body"
        [required]="isFieldRequired(supportForm, 'body')"
        [allowImageInsert]="false">
    </ms-rich-text-editor>
    @if (supportForm.get('body')?.invalid && supportForm.get('body')?.touched) {
        <div class="error-messages">
            @if (supportForm.get('body')?.errors?.['required']) {
                <p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.SupportTicketBodyRequired }}</p>
            }
        </div>
    }

    <!-- Attachments -->
    @if (organizationId(); as orgId) {
        <ms-input-label [labelText]="'Attachments'" class="mt-3" />
        <ms-email-attachments
            [organizationId]="orgId"
            (attachmentsChanged)="onAttachmentsChanged($event)" />
    }

</form>
